import * as React from 'react';
import { AnalyticPropertyInfo } from '../../../../api/Property';
import { Bar } from 'react-chartjs-2';
import '../../../../styles/AdminDashboardPage.css';
import { convert12HrsTimeFormat } from '../helperFunctions/timeFunctions';
import { useState } from 'react';

interface ToursTimeByDayProps {
    dashboardData?: AnalyticPropertyInfo;
  }

  enum TourFrequencyViewType {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
}


  const countOnTopPlugin: Chart.PluginServiceGlobalRegistration & Chart.PluginServiceRegistrationOptions = {
    afterDatasetsDraw: function(chart, easing) {
        console.log(chart)
        if(chart){
            const ctx = chart.ctx;

            // Check if ctx is available
            if (!ctx) {
                return;
            }

            // Check if chart data and datasets exist
            if (chart.data && chart.data.datasets) {
                console.log(chart.data.datasets)
                chart.data.datasets.forEach(function(dataset, datasetIndex) {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    if (!meta || meta.hidden) {
                        return;
                    }

                    // Check if dataset data exists
                    if (!dataset.data) {
                        return;
                    }

                    meta.data.forEach(function(bar, index) {
                        // Check if bar exists
                        if (!bar) {
                            return;
                        }
                        console.log(dataset.data)

                        if(dataset.data && dataset.data[index]!=null){
                        // Get the data value and convert it to string for display
                            const data = dataset.data[index]!.toString();

                            if(data){

                            // Draw the count on top of the bar
                                ctx.fillStyle = 'black';
                                ctx.font = 'bold 12px Arial';
                                ctx.textAlign = 'center';
                                // Accessing chartArea to get the width and calculate the position
                                const x = bar._model.x;
                                const y = bar._model.y - 5;
                                ctx.fillText(data, x, y);

                            }
                        }
                    });
                });
            }

        }
    }
};

export const ToursTimeByDay = ({ dashboardData }: ToursTimeByDayProps) => {

    const [tourFrequencyView, setTourFrequencyView] = useState(TourFrequencyViewType.Sunday);
  
    return  <div className='bordered-card-layout'>
            <div className='row'>
            <p className='dashboard-heading'>Tour Times by Day</p>
                <div className="col-md-4 col-sm-4">
                    <select
                        className="dashboard-select"
                        onChange={event => setTourFrequencyView(parseInt(event.target.value, 10))}
                    >
                        <option value={TourFrequencyViewType.Sunday}>Sunday</option>
                        <option value={TourFrequencyViewType.Monday}>Monday</option>
                        <option value={TourFrequencyViewType.Tuesday}>Tuesday</option>
                        <option value={TourFrequencyViewType.Wednesday}>Wednesday</option>
                        <option value={TourFrequencyViewType.Thursday}>Thursday</option>
                        <option value={TourFrequencyViewType.Friday}>Friday</option>
                        <option value={TourFrequencyViewType.Saturday}>Saturday</option>
                    </select>
                </div>
            </div>
            <Bar
                data={{
                labels: (dashboardData && dashboardData.dashboardTourTImeByDay) ? 
                dashboardData.dashboardTourTImeByDay
                    .filter(data => data.day === TourFrequencyViewType[tourFrequencyView])
                    .map(data => convert12HrsTimeFormat(data.hour)) 
                : [],
                datasets: [
                    {
                        data: (dashboardData && dashboardData.dashboardTourTImeByDay)? dashboardData.dashboardTourTImeByDay.filter(data => data.day === TourFrequencyViewType[tourFrequencyView]).map(data => data.percentage):[],
                        backgroundColor: (dashboardData && dashboardData.dashboardTourTImeByDay) ? 
                        dashboardData.dashboardTourTImeByDay
                            .filter(data => data.day === TourFrequencyViewType[tourFrequencyView])
                            .map(data => {
                                return '#27bbf9'
                            })
                        : []
                    }
                ]
            }}
            options={{
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            ticks: {
                                callback: function(value) {
                                    return `${value}%`; // Format y-axis ticks as percentages
                                }
                            }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if (!data || !data.datasets || !data.datasets.length || !data.labels) return ''; // Check if data, data.datasets, or data.labels is undefined or empty
                            const datasetIndex: number = tooltipItem.datasetIndex !== undefined ? tooltipItem.datasetIndex : -1; // Ensure datasetIndex is typed as number and not undefined
                            const index: number = tooltipItem.index !== undefined ? tooltipItem.index : -1; // Ensure index is typed as number and not undefined
                            const dataset = data.datasets[datasetIndex];
                            if (!dataset || !dataset.data || !dataset.data.length || index === -1) return ''; // Check if dataset or dataset.data is undefined or empty, or index is -1
                            const day = data.labels[index];
                            const item = dashboardData && dashboardData.dashboardTourTImeByDay ? dashboardData.dashboardTourTImeByDay.filter(data => data.day === TourFrequencyViewType[tourFrequencyView]).find(item => {
                                if(day.toString().split(" ")[1]==='AM'){
                                    const hour = parseInt(day.toString().split(" ")[0])
                                    if(hour===12){
                                        //12am is equal 0hr
                                        return item.hour === 0  
                                    }
                                    return item.hour === hour
                                }else{
                                    const hour = parseInt(day.toString().split(" ")[0])
                                    if(hour===12){
                                        // afternoon 12pm case
                                        return item.hour === hour
                                    }
                                    return item.hour === (hour) + 12
                                }
                            }) : { value: 0, percentage: 0 };
                            const value = item ? item.value : 0;
                            return value.toLocaleString('en-US'); // Display count in the tooltip
                        }
                    }
                },
                plugins: [
                    countOnTopPlugin
                ],
                responsive: false,
                layout: {
                    padding: {
                        top: 20,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                maintainAspectRatio: false,
                animation: {
                    duration: 0
                }
                }}
            />
            </div>
}


// WEBPACK FOOTER //
// ./src/components/pages/admin/analyticsDashboardWidgets/toursTimeByDay.tsx